module.exports = ":host {\n  display: flex;\n  flex-direction: column; }\n  :host .cc-button__container {\n    display: flex;\n    justify-content: flex-end; }\n  :host .input__container {\n    margin-bottom: 2em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-components/cost-center/cost-center.presentation.scss
// module id = AIoy
// module chunks = 12